import { render, staticRenderFns } from "./ProtectedKeys.vue?vue&type=template&id=85de2890&"
import script from "./ProtectedKeys.vue?vue&type=script&lang=js&"
export * from "./ProtectedKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports